import React, { Component } from "react";
import Button from "../../../../shared/button/button";
import { isMobile } from "../../../../../js/components/searchform/utils/common";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formatDateToPortugueseFormatWithTime } from "../../../shared/utils";
import Loading from "./../../../../shared/Loading/Loading";
import { onApproveInvite } from "./../../../actions/account-link";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

class AccountLinkDocumentsSent extends Component {
	constructor() {
		super();
		this.state = {
			term: false,
			alreadyCalledApprove: false
		};
		this.nextStep = this.nextStep.bind(this);
	}

	approveInvite() {
		const { data } = this.props;

		this.props.onApproveInvite({
			idManager: data.idManager,
			idParticipant: data.idParticipant,
			relationId: data.relationId,
			docs: [data.idFront, data.idBack, data.selfie, data.declaration]
		});
		this.setState({ alreadyCalledApprove: true });
	}

	nextStep() {
		this.props.incStep(this.state);
	}

	render() {
		const { data, isLoading, sendingFile } = this.props;
		const { alreadyCalledApprove } = this.state;
		if (sendingFile || isLoading) {
			return (
				<Loading
					className="loading-component--documents-send"
					label="Por favor, aguarde enquanto os arquivos são enviados."
				/>
			);
		} else if (!alreadyCalledApprove) {
			this.approveInvite();
		}
		return (
			<React.Fragment>
				{isMobile() ? (
					<div className="account-link-documents-sent">
						<div className="col-xs-16 text-center account-link-documents-sent--box no-padding">
							<div className="col-xs-16 text-center account-link-documents-sent--box--header no-padding">
								<p className="account-link-documents-sent--box--header-status">
									<strong>Solicitação de vínculo enviada</strong>
								</p>
								<p className="account-link-documents-sent--box--header-status-description">
									Agora é só aguardar o gestor aprovar sua solicitação e incluir os documentos dele.{" "}
									<br />Em seguida, a MaxMilhas irá analisar todos os documentos. Esse processo pode
									levar <strong>até 7 dias corridos</strong>
									<br />e o status pode ser acompanhado por aqui. Durante o processo, você
									não pode cadastrar <br />ofertas ou solicitar um novo vínculo, ok?
								</p>
							</div>
							<div className="col-xs-16 text-center account-link-documents-sent--box--info">
								<div className="account-link-documents-sent--box--info--icon">
									<i className="icon-check" />
								</div>

								<div className="row">
									<div className="col-xs-16 text-left">
										<p>
											<strong>Em negociação</strong>
											<br />
											Aguardando aprovação do gestor
										</p>
									</div>
								</div>

								<div className="col-xs-16 offers-divider offers-divider--title" />

								<div className="col-xs-4 text-left account-link-documents-sent--box--info-name no-padding">
									<p>Nome</p>
								</div>
								<div className="col-xs-12 text-left account-link-documents-sent--box--info-name">
									<p>
										<strong>{data.manager.name}</strong>
									</p>
								</div>
								<div className="col-xs-4 text-left account-link-documents-sent--box--info-city no-padding">
									<p>Cidade</p>
								</div>
								<div className="col-xs-12 text-left account-link-documents-sent--box--info-city">
									<p>
										<strong>{data.manager.city}</strong>
									</p>
								</div>
								<div className="col-xs-4 text-left account-link-documents-sent--box--info-cpf no-padding">
									<p>CPF </p>
								</div>
								<div className="col-xs-12 text-left account-link-documents-sent--box--info-cpf">
									<p>
										<strong>{data.manager.ssn}</strong>
									</p>
								</div>

								<div className="col-xs-16 offers-divider offers-divider--title offers-divider--title--date-time" />

								<div className="col-xs-16 account-link-documents-sent--box--info-date-time no-padding">
									<div className="col-xs-4 text-left account-link-documents-sent--box--info-date-time--title no-padding">
										<p>Data de solicitação </p>
									</div>
									<div className="col-xs-12 text-left account-link-documents-sent--box--info-date-time--value">
										<p>
											<strong>{formatDateToPortugueseFormatWithTime(new Date())}</strong>
										</p>
									</div>
								</div>
							</div>

							<div className="col-md-16 text-center account-link-documents-sent--box--ok">
								<div className="account-link-documents-sent--box--ok-button">
									<Button className="btn btn-primary" onClick={() => {
										this.nextStep();
										publish(eventType.ACCOUNT_FAMILY, {
											type: ACCOUNT_FAMILY_EVENT.button_ok
										})
									}}>
										Ok
									</Button>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="account-link-documents-sent">
						<div className="col-xs-16 text-center account-link-documents-sent--box">
							<div className="col-xs-16 text-center account-link-documents-sent--box--header">
								<p className="account-link-documents-sent--box--header-status">
									<strong>Solicitação de vínculo enviada</strong>
								</p>
								<p className="account-link-documents-sent--box--header-status-description">
									Agora é só aguardar o gestor aprovar sua solicitação e incluir os documentos dele.{" "}
									<br />Em seguida, a MaxMilhas irá analisar todos os documentos. Esse processo pode
									levar <strong>até 7 dias corridos</strong> <br />e o status pode ser acompanhado por aqui. Durante o
									processo, você não pode cadastrar <br />ofertas ou solicitar um novo vínculo, ok?
								</p>
							</div>
							<div className="col-xs-16 text-center account-link-documents-sent--box--info">
								<div className="account-link-documents-sent--box--info--icon">
									<i className="icon-check" />
								</div>

								<div className="row">
									<div className="col-xs-6 text-left">
										<p>
											<strong>Em negociação</strong>
											<br />
											Aguardando aprovação do gestor
										</p>
									</div>
								</div>

								<div className="col-xs-16 offers-divider offers-divider--title" />

								<div className="row">
									<div className="col-xs-16 col-md-4 text-left account-link-documents-sent--box--info-name">
										<p>Nome</p>
										<p className="no-margin">
											<strong>{data.manager.name}</strong>
										</p>
									</div>
									<div className="col-xs-16 col-md-4 text-left account-link-documents-sent--box--info-city">
										<p>Cidade</p>
										<p className="no-margin">
											<strong>{data.manager.city}</strong>
										</p>
									</div>
									<div className="col-xs-16 col-md-4 text-left account-link-documents-sent--box--info-cpf">
										<p>CPF</p>
										<p className="no-margin">
											<strong>{data.manager.ssn}</strong>
										</p>
									</div>
									<div className="col-xs-16 col-md-4 text-left account-link-documents-sent--box--info-date-time">
										<p>Data de solicitação</p>
										<p className="no-margin">
											<strong>{formatDateToPortugueseFormatWithTime(new Date())}</strong>
										</p>
									</div>
								</div>
							</div>

							<div className="col-md-16 text-center account-link-documents-sent--box--ok">
								<div className="account-link-documents-sent--box--ok-button">
									<Button className="btn btn-primary" onClick={() => {
										this.nextStep();
										publish(eventType.ACCOUNT_FAMILY, {
											type: ACCOUNT_FAMILY_EVENT.button_ok
										})
									}}>
										Ok
									</Button>
								</div>
							</div>
						</div>
					</div>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	...state.AccountLink,
	data: state.accountLink.dataToSendParticipant,
	isLoading: state.accountLink.isLoading.onApproveInvite,
	sendingFile: state.accountLink.sendingFile
});

const mapDispatchToProps = dispatch => bindActionCreators({ onApproveInvite }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkDocumentsSent);
